import { render, staticRenderFns } from "./VideoApplicationWithCamera.vue?vue&type=template&id=c9a7b0f6&scoped=true&"
import script from "./VideoApplicationWithCamera.vue?vue&type=script&lang=js&"
export * from "./VideoApplicationWithCamera.vue?vue&type=script&lang=js&"
import style0 from "./VideoApplicationWithCamera.vue?vue&type=style&index=0&id=c9a7b0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a7b0f6",
  null
  
)

export default component.exports